import ImageWithTitle from 'containers/Slices/ImageWithTitle';
import ThreeColumnsImages from 'containers/Slices/ThreeColumnsImages';
import TextsOnly from 'containers/Slices/TextsOnly';
import TwoColumnsTab from 'containers/Slices/TwoColumnsTab';
import ImageWithTexts from 'containers/Slices/ImageWithTexts';
import RangesColumnsSeries from 'containers/Slices/RangesColumnsSeries';
import YoutubeVideoWithoutPlay from 'containers/Slices/YoutubeVideoWithoutPlay';
import ImageWithTwoColumns from 'containers/Slices/ImageWithTwoColumns';
import ImageWithBoldTitle from 'containers/Slices/ImageWithBoldTitle';

export const seriesOverviewTab = (
  block,
  type,
  index,
  backgroundColor,
  primaryFontColor,
  secondaryFontColor,
) => {
  switch (type) {
    case 'image_with_title':
      return (
        <ImageWithTitle
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
        />
      );
    case 'three_columns_images':
      return (
        <ThreeColumnsImages
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
        />
      );
    case 'youtube_video':
      return (
        <YoutubeVideoWithoutPlay
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
        />
      );
    case 'texts_only':
      return (
        <TextsOnly
          block={block}
          key={`${type}-${index}`}
          defaultBackgroundColor={backgroundColor}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    case 'two_columns_tab':
      return (
        <TwoColumnsTab
          block={block}
          key={`${type}-${index}`}
          defaultBackgroundColor={backgroundColor}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    case 'image_with_texts':
      return (
        <ImageWithTexts
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    case 'ranges_columns':
      return (
        <RangesColumnsSeries
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    case 'image_with_two_columns':
      return (
        <ImageWithTwoColumns
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    case 'image_with_bold_title':
      return (
        <ImageWithBoldTitle
          block={block}
          key={`${type}-${index}`}
          primaryFontColor={primaryFontColor}
          secondaryFontColor={secondaryFontColor}
        />
      );
    default:
      return '';
  }
};
